import { render, staticRenderFns } from "./ListMemberComponent.vue?vue&type=template&id=15528c0d&scoped=true&"
import script from "./ListMemberComponent.vue?vue&type=script&lang=js&"
export * from "./ListMemberComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListMemberComponent.vue?vue&type=style&index=0&id=15528c0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15528c0d",
  null
  
)

export default component.exports